"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const pacer = require("@tanstack/pacer");
const PacerProvider = require("./provider/PacerProvider.cjs");
const useAsyncBatcher = require("./async-batcher/useAsyncBatcher.cjs");
const useAsyncBatchedCallback = require("./async-batcher/useAsyncBatchedCallback.cjs");
const useAsyncDebouncer = require("./async-debouncer/useAsyncDebouncer.cjs");
const useAsyncDebouncedCallback = require("./async-debouncer/useAsyncDebouncedCallback.cjs");
const useAsyncQueuer = require("./async-queuer/useAsyncQueuer.cjs");
const useAsyncQueuedState = require("./async-queuer/useAsyncQueuedState.cjs");
const useAsyncRateLimiter = require("./async-rate-limiter/useAsyncRateLimiter.cjs");
const useAsyncRateLimitedCallback = require("./async-rate-limiter/useAsyncRateLimitedCallback.cjs");
const useAsyncThrottler = require("./async-throttler/useAsyncThrottler.cjs");
const useAsyncThrottledCallback = require("./async-throttler/useAsyncThrottledCallback.cjs");
const useBatcher = require("./batcher/useBatcher.cjs");
const useBatchedCallback = require("./batcher/useBatchedCallback.cjs");
const useDebouncedCallback = require("./debouncer/useDebouncedCallback.cjs");
const useDebouncedState = require("./debouncer/useDebouncedState.cjs");
const useDebouncedValue = require("./debouncer/useDebouncedValue.cjs");
const useDebouncer = require("./debouncer/useDebouncer.cjs");
const useQueuer = require("./queuer/useQueuer.cjs");
const useQueuedState = require("./queuer/useQueuedState.cjs");
const useQueuedValue = require("./queuer/useQueuedValue.cjs");
const useRateLimitedCallback = require("./rate-limiter/useRateLimitedCallback.cjs");
const useRateLimiter = require("./rate-limiter/useRateLimiter.cjs");
const useRateLimitedState = require("./rate-limiter/useRateLimitedState.cjs");
const useRateLimitedValue = require("./rate-limiter/useRateLimitedValue.cjs");
const useThrottledCallback = require("./throttler/useThrottledCallback.cjs");
const useThrottledState = require("./throttler/useThrottledState.cjs");
const useThrottledValue = require("./throttler/useThrottledValue.cjs");
const useThrottler = require("./throttler/useThrottler.cjs");
exports.PacerProvider = PacerProvider.PacerProvider;
exports.useDefaultPacerOptions = PacerProvider.useDefaultPacerOptions;
exports.usePacerContext = PacerProvider.usePacerContext;
exports.useAsyncBatcher = useAsyncBatcher.useAsyncBatcher;
exports.useAsyncBatchedCallback = useAsyncBatchedCallback.useAsyncBatchedCallback;
exports.useAsyncDebouncer = useAsyncDebouncer.useAsyncDebouncer;
exports.useAsyncDebouncedCallback = useAsyncDebouncedCallback.useAsyncDebouncedCallback;
exports.useAsyncQueuer = useAsyncQueuer.useAsyncQueuer;
exports.useAsyncQueuedState = useAsyncQueuedState.useAsyncQueuedState;
exports.useAsyncRateLimiter = useAsyncRateLimiter.useAsyncRateLimiter;
exports.useAsyncRateLimitedCallback = useAsyncRateLimitedCallback.useAsyncRateLimitedCallback;
exports.useAsyncThrottler = useAsyncThrottler.useAsyncThrottler;
exports.useAsyncThrottledCallback = useAsyncThrottledCallback.useAsyncThrottledCallback;
exports.useBatcher = useBatcher.useBatcher;
exports.useBatchedCallback = useBatchedCallback.useBatchedCallback;
exports.useDebouncedCallback = useDebouncedCallback.useDebouncedCallback;
exports.useDebouncedState = useDebouncedState.useDebouncedState;
exports.useDebouncedValue = useDebouncedValue.useDebouncedValue;
exports.useDebouncer = useDebouncer.useDebouncer;
exports.useQueuer = useQueuer.useQueuer;
exports.useQueuedState = useQueuedState.useQueuedState;
exports.useQueuedValue = useQueuedValue.useQueuedValue;
exports.useRateLimitedCallback = useRateLimitedCallback.useRateLimitedCallback;
exports.useRateLimiter = useRateLimiter.useRateLimiter;
exports.useRateLimitedState = useRateLimitedState.useRateLimitedState;
exports.useRateLimitedValue = useRateLimitedValue.useRateLimitedValue;
exports.useThrottledCallback = useThrottledCallback.useThrottledCallback;
exports.useThrottledState = useThrottledState.useThrottledState;
exports.useThrottledValue = useThrottledValue.useThrottledValue;
exports.useThrottler = useThrottler.useThrottler;
Object.keys(pacer).forEach((k) => {
  if (k !== "default" && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: () => pacer[k]
  });
});
//# sourceMappingURL=index.cjs.map
